import { Component, OnInit, ChangeDetectorRef, ApplicationRef, ViewChild} from '@angular/core';
import { BaseService } from '../../../services/base.services';
import {NgbDate, NgbCalendar, NgbDateParserFormatter, NgbTabsetConfig} from '@ng-bootstrap/ng-bootstrap';
import pageSettings from '../../../config/page-settings';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { formatDate} from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material';
import { DaterangepickerComponent, DaterangepickerDirective } from 'ngx-daterangepicker-material';
import { NgxChartsModule, id } from '@swimlane/ngx-charts';
import { NotificationsService } from '../../../services/notifications.services';
import * as moment from 'moment';
import { registerLocaleData } from '@angular/common';
import es from '@angular/common/locales/es';
import Swal from 'sweetalert2';
import 'sweetalert2/src/sweetalert2.scss';
import 'nvd3';

declare var Highcharts: any;
declare var nv: any;
import * as global from '../../../config/globals';
@Component({
  selector: 'home',
  templateUrl: './home.html',
  styleUrls: ['home.css']
})

export class HomeTaskPage implements OnInit{
  private data:Array<any> = [];
  pageSettings = pageSettings;
  tareas: any = [];
  tareaSeleccionada: any;
  loading = false;
  cargando = false;
  menuMobile: any = [
    {
      Id: 1,
      Nombre: 'Home',
      Icono: 'fa-home',
      Href: '/gestionTareas',
    },
    {
      Id: 2,
      Nombre: 'Mantención',
      Icono: 'fa-cogs',
      Href: '/mantenciones',
    },
    {
      Id: 3,
      Nombre: 'Producción',
      Icono: 'fa-chart-bar',
      Href: '/produccion',
    },
    {
      Id: 4,
      Nombre: 'Actividades',
      Icono: 'fa-list-alt',
      Href: '/actividades',
    },
    {
      Id: 5,
      Nombre: 'Estandares',
      Icono: 'fa-server',
      Href: '/estandares',
    },    
  ]
  menuSelected: any = 1;
  bitacora: any= [];
  message;
  public constructor(
    private baseService: BaseService,
    private calendar: NgbCalendar, 
    public formatter: NgbDateParserFormatter,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private _formBuilder: FormBuilder,
    private router: Router,
    private cd : ChangeDetectorRef,
    private route: ActivatedRoute,
    private appRef: ApplicationRef,
    private config: NgbTabsetConfig,
    private notificationsService: NotificationsService
    ) {
        this.pageSettings.pageEmpty = false;
        this.pageSettings.pageWithoutSidebar = true;
        this.pageSettings.appSelected = null;
        config.justify = 'center';
        registerLocaleData( es );

        this.notificationsService.requestPermission()
        this.notificationsService.receiveMessage()
        this.message = this.notificationsService.currentMessage

  }

  async ngOnInit()  {
    /*this.tareas = [
    { 'Icono': 'fa-plus', 'href':'/gestionTareas', 'Descripcion': 'Realicé mi encuesta COVID', 'checked': true },
    { 'Icono': 'fa-plus', 'href':'/gestionTareas', 'Descripcion': 'Realice desinfección COVID de mi consola', 'checked': true },
    { 'Icono': 'fa-cogs', 'href':'/mantenciones', 'Descripcion': 'Mantenciones.' },
    { 'Icono': 'fa-chart-bar', 'href':'/produccion', 'Descripcion': 'Plan Producción.' },
    { 'Icono': 'fa-list-alt', 'href':'/actividades', 'Descripcion': 'Actividades.' },
    { 'Icono': 'fa-server', 'href':'/estandares', 'Descripcion': 'Revisar Estándares.' },
    ];*/

     this.get_Portada();
     this.get_Bitacora();
  }

  checkTodoList(item) {
    if (item.checked) {
      this.add_Portada(item);
      item.checked = false;
    } else {
      this.add_Portada(item);
      item.checked = true;
    }
  };

  async add_Portada(item){
    try{
      this.cargando = true;
      var _storage = JSON.parse(localStorage.getItem('data'));
      var response = await this.baseService.add_Portada({IdUsuario: _storage.usuario.IDUSUARIO, IdItem:  item.IdItem}).toPromise();
      this.toastr.success('Acción realizada','');
      this.get_Portada();
      this.cargando = false;
    }catch(error){
      this.cargando = false;
      console.log(error);
    }
  }

  
  async get_Portada(){
    try{
      this.cargando = true;
      var _storage = JSON.parse(localStorage.getItem('data'));
      this.tareas = await this.baseService.get_Portada({idUsuario: _storage.usuario.IDUSUARIO}).toPromise();
      console.log(this.tareas);
      this.cargando = false;
    }catch(error){
      this.cargando = false;
      console.log(error);
    }
  }

  async get_Bitacora(){
    try{
      this.cargando = true;
      var _storage = JSON.parse(localStorage.getItem('data'));
      var fecha = moment().format("YYYY-MM-DD");
      console.log(fecha);
      this.bitacora = await this.baseService.get_Bitacora({IdUsuario: _storage.usuario.IDUSUARIO, Fecha: fecha}).toPromise();
      console.log(this.bitacora);
      this.cargando = false;
    }catch(error){
      this.cargando = false;
      console.log(error);
    }
  }

  doTextareaValueChange(ev) {
    try {
      this.tareaSeleccionada.motivo = ev.target.value;
    } catch(e) {
    }
  }
  modalCancelar(modal, tarea){
    this.tareaSeleccionada = tarea;
    this.modalService.open(modal, { size: 'lg' }) 
  }
}
